module.exports = __webpack_public_path__ + "static/BigBang_UAU_SP22_clip-7f162e3d99c5fcf4ee3a72dc729c500e.mp4";